




































import { mapActions, mapGetters } from 'vuex'
import { isServerError, applyCustomErrorConfig } from '@/custom-errors'
import PageContent from '@/components/PageContent.vue'
import MyTransportsFilters from './MyTransportsFilters.vue'
import Table from '@/components/Table.vue'
import TableNoResults from '@/components/TableNoResults.vue'
import ListPagination from '@/components/ListPagination.vue'
import ListStatusBar from '@/components/ListStatusBar.vue'
import ListStatusQuickFilters from '@/components/ListStatusQuickFilters.vue'
import autoReloadMixin from '@/mixins/auto-reload-mixin'
import TransportRow from './TransportRow.vue'
import MyTransportsTableTitles from './MyTransportsTableTitles.vue'
import { PROGRESS_FILTER } from '../constants'

export default {
  components: {
    PageContent,
    MyTransportsFilters,
    ListPagination,
    Table,
    TableNoResults,
    ListStatusBar,
    TransportRow,
    ListStatusQuickFilters,
    MyTransportsTableTitles
  },
  mixins: [autoReloadMixin('loadCurrentTransportsWithQuery')],
  data() {
    return {
      loading: false,
      loadingInitially: true
    }
  },
  computed: {
    ...mapGetters(['transportOrders']),
    listIsEmpty() {
      return !this.transportOrders.orders.length
    },
    emptyStateTitle() {
      return this.$t(
        this.isAnyFilterEnabled
          ? 'table.empty.filters.title'
          : 'myTransports.transportList.empty.noFilters.title'
      )
    },
    emptyStateText() {
      return this.$t(
        this.isAnyFilterEnabled
          ? 'table.empty.filters.text'
          : 'myTransports.transportList.empty.noFilters.text'
      )
    },
    isAnyFilterEnabled() {
      // eslint-disable-next-line
      const { page, size, ...rest } = this.$route.query
      return !!Object.keys(rest).length
    },
    progressFilterOptions() {
      return {
        [PROGRESS_FILTER.ALL]: this.$t('myTransports.all'),
        [PROGRESS_FILTER.FUTURE]: this.$t('myTransports.futureTransports'),
        [PROGRESS_FILTER.ONGOING]: this.$t('myTransports.ongoingTransports'),
        [PROGRESS_FILTER.PAST]: this.$t('myTransports.pastTransports'),
        [PROGRESS_FILTER.CANCELED]: this.$t('myTransports.canceledTransports')
      }
    }
  },
  methods: {
    ...mapActions(['loadTransports', 'triggerReload']),
    async loadCurrentTransportsWithQuery(query) {
      this.loading = true
      try {
        await this.loadTransports(query)
      } catch (err) {
        if (isServerError(err)) {
          this.alertModal.showErrorMessage(
            this.$t('myTransports.transportList.serverError.title'),
            this.$t('myTransports.transportList.serverError.msg'),
            applyCustomErrorConfig
          )
          await this.loadTransports()
        } else {
          throw err
        }
      } finally {
        this.loading = false
        this.loadingInitially = false
      }
    }
  }
}
